import {
    RangeFilterDateAsString,
    RangeFilterInteger,
    SearchFilter,
} from '../../api/generated';

import { useFormikContext } from 'formik';
import { CardViewButton } from '../main/CardViewButton';
import { ListViewButton } from '../main/ListViewButton';

interface InitialValues {
    statusFilter: string[];
    filterToggle: boolean;
    search: SearchFilter;
    siteDaReqFilter: RangeFilterInteger;
    siteDrReqFilter: RangeFilterInteger;
    articleCountsFilter: RangeFilterInteger;
    dueDateFilter: RangeFilterDateAsString;
    toggleView: boolean;
}

export function PredefinedFilters() {
    const formik = useFormikContext<InitialValues>();
    return (
        <div className="predef-row grid sm:grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="grid grid-flow-col auto-cols-max gap-4 text-sm font-bold tracking-wide text-center">
                <button
                    type="button"
                    className="predef-option predef-overdue"
                    onChange={formik.handleChange}
                    onClick={() =>
                        formik.setFieldValue('statusFilter', ['Assigned'])
                    }
                >
                    Assigned
                </button>
                <button
                    type="button"
                    className="predef-option predef-process"
                    onChange={formik.handleChange}
                    onClick={() =>
                        formik.setFieldValue('statusFilter', ['In-Progress'])
                    }
                >
                    In-Progress
                </button>
                <button
                    type="button"
                    className="predef-option predef-done"
                    onChange={formik.handleChange}
                    onClick={() =>
                        formik.setFieldValue('statusFilter', ['Done'])
                    }
                >
                    Done
                </button>
                <button
                    type="button"
                    className="predef-option predef-cancel"
                    onChange={formik.handleChange}
                    onClick={() =>
                        formik.setFieldValue('statusFilter', ['In-Review'])
                    }
                >
                    In-Review
                </button>
                <button
                    type="button"
                    className="predef-option predef-all"
                    onChange={formik.handleChange}
                    onClick={() =>
                        formik.setFieldValue('statusFilter', [
                            'Done',
                            'In-Progress',
                            'In-Review',
                            'Assigned',
                        ])
                    }
                >
                    All
                </button>
            </div>
            <div className="gap-4 text-sm flex justify-end">
                <div className="">
                    <CardViewButton
                        active={formik.values.toggleView}
                        setFieldAttribute="toggleView"
                        setFieldValue
                    />
                </div>
                <div className="">
                    <ListViewButton
                        active={!formik.values.toggleView}
                        setFieldAttribute="toggleView"
                        setFieldValue={false}
                    />
                </div>
            </div>
        </div>
    );
}
